import { useAuthStore } from '@/features/auth/store'

/** Read-only view of the session. */
export function useAuth() {
  const user = useAuthStore((state) => state.user)
  const status = useAuthStore((state) => state.status)
  const isBootstrapped = useAuthStore((state) => state.isBootstrapped)

  return {
    user,
    status,
    isBootstrapped,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'idle' || status === 'bootstrapping',
  }
}

/** Session actions, kept separate so components that only act do not re-render. */
export function useAuthActions() {
  const login = useAuthStore((state) => state.login)
  const logout = useAuthStore((state) => state.logout)
  const bootstrap = useAuthStore((state) => state.bootstrap)
  const reloadProfile = useAuthStore((state) => state.reloadProfile)

  return { login, logout, bootstrap, reloadProfile }
}

/** True when the user holds at least one of `roles` (empty `roles` means "any"). */
export function useHasRole(roles: string[]): boolean {
  const user = useAuthStore((state) => state.user)

  if (roles.length === 0) return true
  return Boolean(user?.roles.some((role) => roles.includes(role)))
}
